module.exports = __webpack_public_path__ + "img/EMC_G_2.3266fcf7.png";